import { Link } from 'react-router-dom';
import './Home.css';
import edunexus from './../../../../assets/edunexus.png';
import Header from '../../partials/Header/Header';
import Footer from '../../partials/Footer/Footer';
import Button from '../../../../components/Button/Button';
import { useAuth } from '../../../../contexts/AuthContext';

function Home() {
    const { user } = useAuth();
    const isAuth = !!user;

    const mostPopularCourses = () => {
        return [
            { id: 1, title: "Teste 1", subscribers: "100+", image: "" },
            { id: 2, title: "Teste 2", subscribers: "200+", image: "" },
            { id: 3, title: "Teste 3", subscribers: "300+", image: "" },
            { id: 4, title: "Teste 4", subscribers: "400+", image: "" },
            { id: 5, title: "Teste 5", subscribers: "500+", image: "" },
            { id: 6, title: "Teste 6", subscribers: "600+", image: "" },
        ]
    }

    const availableTools = () => {
        return [
            { id: 1, title: "SCORM Support", description: "Importe e execute pacotes SCORM (1.2 / 2004) com rastreamento de progresso.", icone: "fa-solid fa-box-open" },
            { id: 2, title: "Certificados", description: "Emissão automática de certificados personalizáveis ao concluir cursos.", icone: "fa-solid fa-certificate" },
            { id: 3, title: "Quizzes & Avaliações", description: "Banco de questões, tipos diversos e correção automática com relatórios.", icone: "fa-solid fa-clipboard-check" },
            { id: 4, title: "Fóruns & Discussões", description: "Espaço para interação, threads e moderação por instrutores.", icone: "fa-solid fa-comments" },
            { id: 5, title: "Video Support", description: "Reprodução de conteúdo de vídeo em formatos diversos.", icone: "fa-solid fa-video" },
            { id: 6, title: "Relatórios Avançados", description: "Análise detalhada do desempenho dos alunos e engajamento.", icone: "fa-solid fa-chart-line" },
            { id: 7, title: "Gamificação", description: "Sistema de pontos, badges e níveis para engajar alunos.", icone: "fa-solid fa-gamepad" },
            { id: 8, title: "Integração com Ferramentas Externas", description: "Conecte-se a ferramentas populares via APIs e plugins.", icone: "fa-solid fa-plug" },
        ]
    }

    return (
        <div id="home">
            <Header />

            <main>
                <section id="index" className="container">
                    <div className="auth">
                        <div className="title">
                            <img src={edunexus} alt="" />
                        </div>

                        {!isAuth && (
                            <div className="auth-buttons">
                                <Link to="/login" className="link">
                                    <Button id="login" name="Login" />
                                </Link>

                                <Link to="/register" className="link">
                                    <Button id="register" name="Register" />
                                </Link>
                            </div>
                        )}
                    </div>

                    <div className="message">
                        <div className="content">
                            <div className="subtitle">
                                <h2>Lorem ipsum dolor sit amet</h2>
                            </div>

                            <div className="text">
                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia, doloremque.</p>
                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia, doloremque.</p>
                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia, doloremque.</p>
                            </div>
                        </div>
                    </div>
                </section>

                <section id="available-tools" className="container">
                    <div className="title">
                        <h2>Available Tools</h2>
                    </div>

                    <div className="tools">
                        {availableTools().map((tool) => (
                            <article className="tool" key={tool.id}>
                                <div className="icon">
                                    <i className={tool.icone}></i>
                                </div>
                                <h3>{tool.title}</h3>
                                <p>{tool.description}</p>
                            </article>
                        ))}
                    </div>

                    <Link to="/tools" className="link">
                        <Button id="see_all_tools" name="See All Tools" />
                    </Link>
                </section>

                <section id="popular-courses" className="container">
                    <div className="title">
                        <h2>Most Popular Courses</h2>
                    </div>

                    <div className="courses" role="list">
                        {mostPopularCourses().map((course) => (
                            <article className="card" role="list" key={course.id}>
                                <div className="card-media">
                                    <img src={edunexus} alt="Ilustração de estudo" loading="lazy" />
                                    <div className="badge">{course.subscribers} subscribers</div>
                                </div>
                                <div className="card-body">
                                    <h3 className="card-title">
                                        {course.title}
                                    </h3>
                                    <p className="card-description">
                                        Lore ipsum dolor sit amet consectetur adipisicing elit.
                                    </p>
                                    <div className="card-cta">
                                        <Link to={`/courses/${course.id}`} className="link">
                                            <Button id="see_course" name="Acessar" />
                                        </Link>
                                    </div>
                                </div>
                            </article>
                        ))}
                    </div>

                    <Link to="/courses" className="link">
                        <Button id="see_all_courses" name="See All Courses" />
                    </Link>
                </section>

                <section id="about-us" className="container">
                    <div className="title">
                        <h2>About Us</h2>
                    </div>

                    <div className="content">
                        <p>
                            O EduNexus é uma plataforma LMS / AVA pensada pra quem quer ensinar e aprender sem enrolação. Criamos um ambiente robusto, intuitivo e escalável onde instituições, empresas e produtores de conteúdo entregam experiências de aprendizagem modernas — do curso rápido ao programa corporativo completo.
                        </p>

                        <p>
                            Nossa proposta é simples: transformar conhecimento em resultado. Pra isso, unimos um editor de conteúdo flexível, suporte a pacotes SCORM e xAPI, ferramentas de avaliação (quizzes, tarefas, rubricas), trilhas de aprendizagem e emissão automática de certificados. Tudo com painéis e relatórios que ajudam instrutores e gestores a tomar decisão com dados reais.
                        </p>

                        <p>
                            Pro aluno, o foco é praticidade. Interface responsiva, navegação clara, acompanhamento de progresso, feedbacks imediatos e conteúdo multimídia. Pra quem ensina, entregamos ferramentas de interação: fóruns, salas ao vivo, comentários, criação colaborativa de materiais e relatórios de desempenho detalhados — sem precisar ser dev pra montar um curso.
                        </p>

                        <div className="mission-vision">
                            <h3>Missão</h3>
                            <p>
                                Democratizar o acesso ao ensino de qualidade e transformar aprendizagem em impacto mensurável. Buscamos facilitar o trabalho do professor e aumentar a retenção e aplicabilidade do conteúdo pelo aluno — na moral, sem complicar.
                            </p>

                            <h3>Visão</h3>
                            <p>
                                Ser a plataforma de referência para quem quer unir tecnologia e educação com foco em resultados reais: capacitação prática, upskilling e desenvolvimento contínuo.
                            </p>
                        </div>

                        <div className="highlights">
                            <h3>Diferenciais</h3>
                            <ul>
                                <li>Compatibilidade com SCORM, xAPI e importação de pacotes.</li>
                                <li>Relatórios e analytics avançados para acompanhamento de métricas.</li>
                                <li>Integrações via API, SSO (OAuth / SAML) e webhooks.</li>
                                <li>Editor WYSIWYG e suporte a conteúdo multimídia (vídeo, PDF, simuladores).</li>
                                <li>Gamificação, badges e trilhas de aprendizagem para engajamento.</li>
                                <li>Controle de permissões granular para admins, instrutores e mentores.</li>
                                <li>Hospedagem escalável e opções de deployment on-premises ou cloud.</li>
                            </ul>
                        </div>

                        <div className="security-accessibility">
                            <h3>Segurança & Acessibilidade</h3>
                            <p>
                                Privacidade e segurança são prioridades: criptografia, backup automático e conformidade com boas práticas de mercado. Também nos preocupamos com acessibilidade — interface compatível com leitores de tela e navegação por teclado.
                            </p>
                        </div>

                        <div className="cta">
                            <p>
                                Quer testar na prática? A gente tem demos, migração assistida e suporte técnico pra colocar seu conteúdo no ar rapidinho. Fala com a galera do EduNexus e bora transformar seu conteúdo em impacto real.
                            </p>
                        </div>
                    </div>
                </section>

                <section id="contact" className="container">
                    <div className="title">
                        <h2>Contact Us</h2>
                    </div>

                    <div className="content">
                        <div className="contact-wrapper">
                            <div className="contact-info">
                                <h3>Informações de Contato</h3>
                                <div className="info-item">
                                    <i className="fa-solid fa-envelope"></i>
                                    <p>contato@edunexus.tech</p>
                                </div>
                                <div className="info-item">
                                    <i className="fa-solid fa-phone"></i>
                                    <p>+55 (19) 99000-8662</p>
                                </div>
                                <div className="info-item">
                                    <i className="fa-solid fa-location-dot"></i>
                                    <p>Limeira, SP - Brasil</p>
                                </div>
                                <div className="social-media">
                                    <a
                                        href="https://www.linkedin.com/company/edunexus"
                                        target="_blank"
                                        className="social-link"
                                        rel="noopener noreferrer"
                                    >
                                        <i className="fa-brands fa-linkedin"></i>
                                    </a>
                                    <a
                                        href="https://www.instagram.com/edunexus.tech/"
                                        target="_blank"
                                        className="social-link"
                                        rel="noopener noreferrer"
                                    >
                                        <i className="fa-brands fa-instagram"></i>
                                    </a>
                                    <a
                                        href="https://www.youtube.com/@edunexus"
                                        target="_blank"
                                        className="social-link"
                                        rel="noopener noreferrer"
                                    >
                                        <i className="fa-brands fa-youtube"></i>
                                    </a>
                                </div>
                            </div>

                            <form className="contact-form">
                                <h3>Envie sua Mensagem</h3>
                                <div className="form-group">
                                    <input type="text" placeholder="Nome" required />
                                </div>
                                <div className="form-group">
                                    <input type="email" placeholder="Email" required />
                                </div>
                                <div className="form-group">
                                    <input type="text" placeholder="Assunto" required />
                                </div>
                                <div className="form-group">
                                    <textarea placeholder="Mensagem" rows={5} required></textarea>
                                </div>

                                <Button id="send_message" name="Enviar Mensagem" />
                            </form>
                        </div>
                    </div>
                </section>
            </main>

            <Footer />
        </div>
    )
}

export default Home;